var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ffmpeg"},[_c('input',{attrs:{"type":"file","accept":"video/mp4"},on:{"change":_vm.onFileChange}}),_c('button',{attrs:{"disabled":!_vm.videoFile},on:{"click":function($event){return _vm.extractAudio()}}},[_vm._v("提取音频")]),(_vm.audioUrl)?_c('audio',{attrs:{"src":_vm.audioUrl,"controls":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }